"use client";
import { Switch } from "@cmp-src/primitives/Switch";
import React, { useState } from "react";
import { cn } from "@gettactic/helpers/src/css/cn";
import { useTeams } from "@/features/teams/hooks/useTeams";
import { Button } from "@cmp-src/primitives/button";
import { SearchableList } from "@/ui/lists/SearchableList/SearchableList";
import { TeamListItem } from "@/features/users/components/UserSettingsPanel/TeamListItem";
import { ITeam } from "@gettactic/api";
function useTeamListAndRequired(userIds: string[], query: string) {
  //@todo complete users with what is listed on userIds
  const { teamList } = useTeams({ type: "directory", hidden: true });
  return {
    list: (teamList?.elements ?? []).filter(
      (x: ITeam) =>
        !query || x.name.toLowerCase().indexOf(query.toLowerCase()) > -1
    )
  };
}

type Props = {
  ids: string[];
  add: (id: string) => void;
  remove: (id: string) => void;
};
export function TeamsPermissionList({ ids, add, remove }: Props) {
  const [currentOver, setCurrentOver] = useState("");
  const [query, setQuery] = useState("");
  const [displayOnlyAssigned, setDisplayOnlyAssigned] = useState(false);
  const { list } = useTeamListAndRequired(ids, query);
  return (
    <SearchableList
      teamSearchQuery={query}
      setSearchQuery={setQuery}
      actionElement={
        <div className="flex items-center gap-3">
          <span className="text-base font-medium text-neutral-900">All</span>
          <Switch
            checked={displayOnlyAssigned}
            onCheckedChange={() => setDisplayOnlyAssigned((x) => !x)}
          />
          <span className="text-base font-medium text-neutral-900">
            Can Reserve
          </span>
        </div>
      }
    >
      {list
        ? list.map((team: ITeam) => {
            const alreadyIn = ids.indexOf(team.id) > -1;
            if (displayOnlyAssigned && !alreadyIn) {
              return <></>;
            }
            return (
              <TeamListItem
                key={team.id}
                team={team}
                rightElement={
                  <Button
                    variant={alreadyIn ? "default" : "outline"}
                    size="sm"
                    onMouseOver={() => setCurrentOver(team.id)}
                    onMouseLeave={() => setCurrentOver("")}
                    onClick={() => (alreadyIn ? remove(team.id) : add(team.id))}
                  >
                    {alreadyIn
                      ? currentOver === team.id
                        ? "Remove"
                        : "Can Reserve"
                      : "Add"}
                  </Button>
                }
              />
            );
          })
        : null}
    </SearchableList>
  );
}
